import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import i18n from './i18n'

const app = createApp(App)
app.use(i18n).use(store).use(router).mount('#app')
app.provide('axios', app.config.globalProperties.axios)
